import styled from 'styled-components'

export const StyledText = styled.span`
  display: block;
  color: #dc3545;
  font-size: 12px;
  margin-top: 2px;
`
